import styled from 'styled-components';
import tw from 'twin.macro';
import { Body } from '../../styled components/Typography';

/*
 *  'min-w-0': Flex hack to have the class `break-words` to work in a flex environment.
 *  'break-words': Let the textual content break in a nice way
 */
export const NetworkDisconnectionContainer = styled.div(({ $withBackground }) => [
  tw`fixed w-full h-full min-w-full max-w-full min-h-full z-1000`,
  $withBackground
    ? 'background: repeating-linear-gradient(111deg, #fafafa, #fafafa 3px, #ffdc00 3px, #ffdc00 4px);'
    : 'background-color: rgba(0,0,0,0.1);'
]);

export const NetworkDisconnectionBody = styled(Body)(() => [
  tw`absolute bottom-0 w-full bg-yellow-base text-center p-16`
]);

export const NetworkDisconnectionRetryContainer = styled.div(() => [
  tw`m-8 flex justify-center`
]);
